import React, { useMemo, useState, useEffect } from "react";
import { formatRowData } from "./ReadyforPickupOrdersData";
import { OrderStatusConstant, OrderStatusConstants } from "../../common/constants";
import { useTranslation } from "react-i18next";
import AppTable from "./AppTable";
import Pagination from "./Pagination";
import OverviewFilter from "./OverviewFilter";
import ReadyforPickupDocuments from "./ReadyforPickupDocuments";
import { groupbyArrayN } from "./Data";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCurrentOrderList,
  GetLawyersByFirmID,
  lawFirmSelector,
} from "../../features/lawFirm/lawFirmSlice";
import {
  GetDocStoreDetails,
  orderSummarySelector,
} from "../../features/ordersSummary/orderSummarySlice";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { ReadDocumentAsStream } from "../../features/uploadDocument/uploadDocumentSlice";
import { GetFirmByUserID } from "../../features/managebilling/manageBillingSlice";
import { Link, Outlet, useLocation, useMatch, useParams } from "react-router-dom";
import { getLawfirmForInternalUser } from "../../common/utils";

function ReadyForPickupOrders({ readyForPickOrders, firmIDAndName }) {
  const [ViewDocs, setViewDocs] = useState(null);
  const [filenumber, setFilenumber] = useState("");
  const [fileid, setFileid] = useState("");
  const { DocStoreDetails } = useSelector(orderSummarySelector);
  const { userLogin } = useSelector(authLoginSelector);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { lawyersByFirm, DashboardLawfirm } = useSelector(lawFirmSelector);

  const [LawyerOptions, setLawyerOptions] = useState([]);

  const setDocsView = (filenumber, fileID) => {
    setFilenumber(filenumber);
    setFileid(fileID);
    dispatch(GetDocStoreDetails(fileID, userLogin?.userId));
  };

  const { id } = useParams();

  useEffect(() => {
    setViewDocs(DocStoreDetails?.DocStore);
  }, [DocStoreDetails]);

  const viewFile = (storageFileID) => {
    dispatch(ReadDocumentAsStream(storageFileID, userLogin?.userId, 1));
  };

  let match = useMatch('/orderstatus/*');
  const location = useLocation();

  const columns = (userLogin) => {
    //const { t } = useTranslation();
    return [
      {
        Header: t("OrdernumHeader"),
        accessor: "fileNumber",
        width: 30,
        Cell: ({ row }) => {
          //spread the props
          //const redirectURL = `process/${row.original.filenumberEncrypted}`;
          const redirectURL =
            row.original.status &&
              row.original.status.toLowerCase() === "not yet submitted"
              ? `../order/${row.original.fileNumber}`
              : `../ordersummary/${row.original.fileNumber}?tab=docstore`;
          return (
            <div className="ml-3">
              <a href={redirectURL} className="fileNumber text-secondary-blue">
                {row.original.fileNumber}
              </a>
              <br />
              {/* <span className="internalReference">
                {row.original.internalReference}
              </span> */}
            </div>
          );
        },
      },
      {
        Header: t("fileorReferenceHeader"),
        accessor: "internalReference",
        width: 30,
      },
      // {
      //   Header: t("LawyerNameHeader"),
      //   accessor: "lawyerName",
      //   width: 100,
      // },
      {
        Header: t("ClientNameHeader"),
        accessor: "clients",
        width: 140,
        expandLength: 16,
        expanded: false,
        Cell: ({ row }) => {
          //spread the props
          //const redirectURL = `process/${row.original.filenumberEncrypted}`;
          const clientsArray = row.original.clients.split(',');
          return (
            <div className="ml-3">
              {clientsArray.map((item) => {

                return (
                  <div> {item}<br /></div>
                )
              })}

            </div>
          );
        },
      },
      {
        Header: t("PropertyAddressHeader"),
        accessor: "propertyAddress",
        width: 350,
        itemsToShow: 1,
        expandLength: 100,
        expanded: false,
        Cell: ({ row }) => {
          //spread the props
          //const redirectURL = `process/${row.original.filenumberEncrypted}`;
          const propArray = row.original.propertyAddress.split(';');
          return (
            <div className="ml-3">
              {propArray.map((item) => {

                return (
                  <div> {item}<br /></div>
                )
              })}

            </div>
          );
        },
      },
      {
        Header: t("DealTypeHeader"),
        accessor: "dealType",
        width: 100,
      },
      // {
      //   Header: t("ClosingDateHeader"),
      //   accessor: "closingDate",
      //   width: 100,
      //   expanded: false,
      //   Cell: ({ row }) => {
      //     //spread the props
      //     //const redirectURL = `process/${row.original.filenumberEncrypted}`;
      //     const dateArray=row.original.closingDate?.split(',');
      //     return (
      //       <div className="ml-3">
      //         {dateArray?.map((item)=>{

      //           return (
      //         <div> {item}<br/></div>
      //           )
      //         })}

      //       </div>
      //     );
      //   },
      // },
      {
        Header: t("Documents"),
        //accessor: "status",
        width: 50,
        ToolTip: true,
        Cell: ({ row }) => {
          //spread the props
          return (
            <div className="ml-1">
              <button
                className="cursor-pointer flex float-left font-[600] items-center justify-center px-[5px] text-[#526D7D] w-max"
              // onClick={() =>
              //   setDocsView(row.original.fileNumber, row.original.fileID)
              // }
              >
                <Link to={`/orderstatus/policypickupdocs/${row.original.fileNumber}`}>{t("viewDocs")}</Link>

              </button>
            </div>
          );
        },
      },
    ];
  };

  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalOrders: 0,
    column: null,
    order: "ascending",
  });

  const [currentPage, setCurrentPage] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  const [ordersPerPage, setOrdersPerPage] = useState(10);
  const { totalOrderCount, loadingOrderList } = useSelector(lawFirmSelector);

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    if (readyForPickOrders?.length > 0) {
      // Use totalOrderCount from API if available, otherwise fallback to array length
      // const total = totalOrderCount > 0 ? totalOrderCount : readyForPickOrders.length;
      const total = readyForPickOrders[0]?.totalRows || 0;
      setPageData({
        isLoading: loadingOrderList,
        rowData: formatRowData(readyForPickOrders,currentLanguage ),
        totalPages: Math.ceil(total / ordersPerPage),
        totalOrders: total,
      });
    } else {
      setPageData({
        isLoading: loadingOrderList,
        rowData: [],
        totalPages: 0,
        totalOrders: 0,
      });
    }
  }, [readyForPickOrders, totalOrderCount, ordersPerPage, loadingOrderList,currentLanguage]);

  const onSort = (column, order) => {
    setPageData((prevState) => ({
      ...prevState,
      column,
      order,
    }));
    // Reset to first page when sorting changes
    setCurrentPage(0);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Trigger API call when page, sort, or filters change
  useEffect(() => {
    if (filterValues && Object.keys(filterValues).length > 0) {
      let { dateValue, deals, lawyerValue, search } = filterValues;
      if (typeof lawyerValue === "object") {
        lawyerValue = lawyerValue?.map(x => x.value).join(",")
      }
      if (firmIDAndName === null) return;
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          3,
          dateValue || "",
          deals || "All",
          userLogin?.isLawyer ? (lawyerValue || (userLogin?.internalUser ? "" : userLogin?.userId.toString())) : (lawyerValue || ""),
          "Ready for Pickup",
          search || "",
          true,
          pageData.column,
          pageData.order,
          userLogin?.internalUser ? "" : !userLogin?.isLawyer ? userLogin?.userId.toString() : "",
          currentPage + 1, // API expects 1-based page number
          ordersPerPage
        )
      );
    }
  }, [currentPage, pageData.column, pageData.order, filterValues, firmIDAndName]);

  const [selectedReadyForpickupOrders, setselectedReadyForpickupOrders] = useState({});
  const [isHeaderChecked, setisHeaderChecked] = useState(false);

  useEffect(() => {
    if (lawyersByFirm?.length === 0)
      dispatch(GetLawyersByFirmID(getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser)));
    else {
      let lawyeroptions = [];
      lawyeroptions.push({ label: t('All'), value: "All" });
      lawyersByFirm?.lawyers?.map((item, i) => {
        lawyeroptions.push({ label: t(item.lawyer), value: item.userID });
      });
      setLawyerOptions(lawyeroptions);
    }
  }, [firmIDAndName, lawyersByFirm]);

  const reloadtabs = () => {
    if (firmIDAndName === null)
      dispatch(GetFirmByUserID(userLogin && userLogin?.userId));
    if (firmIDAndName !== null)
      dispatch(GetLawyersByFirmID(getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser)));
    if (firmIDAndName !== null && userLogin?.isLawyer) {
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          null,
          "",
          "All",
          userLogin?.internalUser ? "" : userLogin?.userId.toString(),
          "Ready for Pickup",
          isHeaderChecked && (id?.toString() !== "" && id?.toString() !== undefined) ? id?.toString() : "",
          false,
          "",
          "",
          "",
          1,
          10
        )
      );
    }

    if (firmIDAndName !== null && !userLogin?.isLawyer) {
      // dispatch(GetProfileDetails(userLogin.userId, false));
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          null,
          "",
          "All",
          "",
          "Ready for Pickup",
          isHeaderChecked && (id?.toString() !== "" && id?.toString() !== undefined) ? id?.toString() : "",
          false,
          "",
          "",
          userLogin?.userId.toString(),
          1,
          10
        )
      );
    }
  };

  useEffect(() => {
    if (id?.toString() !== "" && id?.toString() !== undefined && parseInt(id) > 0) {
      setisHeaderChecked(true);
      reloadtabs();
      setselectedReadyForpickupOrders(pageData?.rowData?.filter(x => x.fileNumber === parseInt(id)));

    }
  }, [id, location])


  const DealTypeOptions = OrderStatusConstant("DealType").map(
    (item, i) => {
      return { label: t(item.label), value: item.value };
    }
  );
  const StatusOptions = OrderStatusConstants.StatusOptions.map((item, i) => {
    return { label: t(item.label), value: item.value };
  });


  return (
    <div>
      {!location.pathname.includes('policypickupdocs') &&
        <h1 className="font-bold mb-[24px] w-[1260px]">
          {t("ReadyforpickupDescription")}
        </h1>
      }
      {!location.pathname.includes('policypickupdocs') && (
        <>
          <OverviewFilter
            // loading={loading}
            DealTypeOptions={DealTypeOptions}
            LawyerOptions={LawyerOptions}
            StatusOptions={StatusOptions}
            onFilter={(values) =>
              setFilterValues((prev) => ({ ...prev, ...values }))
            }
            isReadyforPickup={true}
            selectedReadyForpickupOrders={selectedReadyForpickupOrders}
            firmIDAndName={firmIDAndName}
            tab={3}
            setSelectedRows={setselectedReadyForpickupOrders}
            reloadTabs={reloadtabs}
            onPageReset={() => setCurrentPage(0)}
            currentPage={currentPage}
            pageSize={ordersPerPage}
            sortColumn={pageData.column}
            sortOrder={pageData.order}
            initialStatusFilter={"Ready for Pickup"}
          />
          <div style={{ height: "auto" }}>
            {pageData.rowData && pageData.rowData.length > 0 && (
              <AppTable
                columns={columns}
                data={pageData?.rowData}
                isLoading={pageData.isLoading}
                onSort={onSort}
                manualSorting
                pickupInvoice
                setSelectedRows={setselectedReadyForpickupOrders}
                isHeaderChecked={isHeaderChecked}
              />
            )}
          </div>
          <br />
          {!pageData.rowData || pageData?.rowData?.length === 0 &&
            <div className="text-center text-secondary-red font-semibold text-lg">
              {t('noResults')}
            </div>
          }
          <div>
            {(readyForPickOrders && readyForPickOrders?.length > 0 && pageData.totalOrders > 0) && (
              <Pagination
                totalRows={pageData.totalOrders}
                pageChangeHandler={handlePageChange}
                rowsPerPage={ordersPerPage}
                currentPage={currentPage}
              />
            )}
          </div>
        </>
      )}

      {/* {ViewDocs && (
        <ReadyforPickupDocuments
          docresponse={ViewDocs}
          setViewDocs={setViewDocs}
          filenumber={filenumber}
          fileID={fileid}
          viewFile={viewFile}
          userLogin={userLogin}
         
        />
      )} */}
      {location.pathname.includes('policypickupdocs') && <Outlet />}
    </div>
  );
}

export default ReadyForPickupOrders;
